import * as yup from "yup";
import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import MyDialogContent from "@/components/MyDialogContent";
import RHFWrapper from "@/components/RHFWrapper";
import RhfInput from "@/components/rhfFields/RhfInput";

export type TcmAppointmentAction = "reschedule" | "cancel";

type Props = {
  action: TcmAppointmentAction | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string) => void;
};

export function TcmAppointmentReasonDialog({ action, onOpenChange, onConfirm }: Props) {
  const isCancel = action === "cancel";

  return (
    <Dialog open={action !== null} onOpenChange={onOpenChange}>
      <MyDialogContent heading={isCancel ? "Cancel Appointment" : "Reschedule Appointment"}>
        <RHFWrapper
          className="space-y-4"
          initialValues={{ reason: "" }}
          isValidate
          validateSchema={yup.object({
            reason: yup.string().trim().required("Reason is required"),
          })}
          onSubmit={(data: { reason: string }) => {
            onConfirm(data.reason.trim());
            onOpenChange(false);
          }}
        >
          <RhfInput
            name="reason"
            label="Reason"
            type="textarea"
            required
            rows={4}
            placeholder={
              isCancel
                ? "Why is this appointment being cancelled?"
                : "Why is this appointment being rescheduled?"
            }
          />
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Close
            </Button>
            <Button type="submit">{isCancel ? "Cancel Appointment" : "Continue"}</Button>
          </div>
        </RHFWrapper>
      </MyDialogContent>
    </Dialog>
  );
}
